'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dCredentials$002dUsage$002dPage$0024 from "./presto.-Credentials-Usage-Page$.js";
import * as $j_presto$002e$002dPresto$002dRouter$0024$0024anon$002453 from "./presto.-Presto-Router$$anon$53.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$52() {
  this.biT = null;
  this.biL = null;
  this.biM = false;
  this.biU = null;
  this.biV = false;
  this.biY = null;
  this.biR = null;
  this.biS = false;
  this.biN = null;
  this.biO = false;
  this.biP = null;
  this.biQ = false;
  this.biW = false;
  this.biX = false;
  this.biT = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.biY = "CredentialsUsagePage";
}
export { $c_Lpresto_PrestoRouter$$anon$52 as $c_Lpresto_PrestoRouter$$anon$52 };
$p = $c_Lpresto_PrestoRouter$$anon$52.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$52;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$52() {
}
export { $h_Lpresto_PrestoRouter$$anon$52 as $h_Lpresto_PrestoRouter$$anon$52 };
$h_Lpresto_PrestoRouter$$anon$52.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.I = (function() {
  return this.biT;
});
$p.M = (function() {
  if ((!this.biM)) {
    this.biL = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.biM = true;
  }
  return this.biL;
});
$p.O = (function() {
  if ((!this.biV)) {
    this.biU = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.biV = true;
  }
  return this.biU;
});
$p.E = (function() {
  return this.biY;
});
$p.t = (function() {
  if ((!this.biS)) {
    this.biR = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.biS = true;
  }
  return this.biR;
});
$p.N = (function() {
  if ((!this.biO)) {
    this.biN = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.biO = true;
  }
  return this.biN;
});
$p.Q = (function() {
  if ((!this.biQ)) {
    this.biP = new $j_presto$002e$002dPresto$002dRouter$0024$0024anon$002453.$c_Lpresto_PrestoRouter$$anon$53();
    this.biQ = true;
  }
  return this.biP;
});
$p.v = (function() {
  if ((!this.biX)) {
    this.biW = false;
    this.biX = true;
  }
  return this.biW;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee398) => ((p) => \u03b4scrutinee398))($j_presto$002e$002dCredentials$002dUsage$002dPage$0024.$m_Lpresto_CredentialsUsagePage$())));
});
var $d_Lpresto_PrestoRouter$$anon$52 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$52, "presto.PrestoRouter$$anon$52", ({
  Ot: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$52 as $d_Lpresto_PrestoRouter$$anon$52 };
//# sourceMappingURL=presto.-Presto-Router$$anon$52.js.map
